import { render, staticRenderFns } from "./CompanyLogo.vue?vue&type=template&id=6781f8f4&scoped=true"
import script from "./CompanyLogo.vue?vue&type=script&lang=js"
export * from "./CompanyLogo.vue?vue&type=script&lang=js"
import style0 from "./CompanyLogo.vue?vue&type=style&index=0&id=6781f8f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6781f8f4",
  null
  
)

export default component.exports